// ─── Shared Dumpster Details Lookup ──────────────────────────────────────────

export const DUMPSTER_DETAILS_LOOKUP: Record<string, { vendor: string; size: string }> = {
  'J-1005': { vendor: 'Rumpke', size: '20yd' },
  'J-1008': { vendor: 'Waste Management', size: '20yd' },
  'J-1011': { vendor: 'Rumpke', size: '30yd' },
  'J-1014': { vendor: 'Republic Services', size: '20yd' },
  'J-1017': { vendor: 'Waste Management', size: '12yd' },
  'J-1021': { vendor: 'Rumpke', size: '30yd' },
  'J-1023': { vendor: 'Waste Management', size: '20yd' },
};

export const getDumpsterDetails = (jobId: string): { vendor: string; size: string } => {
  return DUMPSTER_DETAILS_LOOKUP[jobId] ?? { vendor: 'TBD', size: '—' };
};
